import {http} from '@/src/services/config/config-receituario'

export default{
    generateAndDownload:(token, receitaInfo)=>{
        return http.post('csv/escrever', receitaInfo, {
            headers:{
                'Authorization':token
            }
        })
       
    },

    generateStockSiga:(token, receitaInfo)=>{
        return http.post('csv/arquivo-estoque-siga', receitaInfo, {
            headers:{
                'Authorization':token
            }
        })
    },

    generateAndDownloadSP:(token, receitaInfo)=>{
        return http.post('csv/arquivo-sp', receitaInfo, {
            headers:{
                'Authorization':token
            }
        }) 
    },
    generateAndDownloadBA:(token, receitaInfo)=>{
        return http.post('csv/arquivo-estoque-bahia', receitaInfo, {
            headers:{
                'Authorization':token
            }
        }) 
    },
}